import React from 'react';
import '../../styles/permitForms.css';
import BidNotesForm from './BidNotesForm';
import PermitRequestForm from './PermitRequestForm';
import PreliminaryInfoForm from './PreliminaryInfoForm';
import ProjectChecklistForm from './ProjectChecklistForm';
import DailyChecklistForm from './DailyChecklistForm';
import WarrantyCertificateForm from './WarrantyCertificateForm';
import TileForm from './TileForm';
import SlateForm from './SlateForm';
import SinglePlyForm from './SinglePlyForm';
import CompositionShingleForm from './CompositionShingleForm';
import PrepDryInForm from './PrepDryInForm';
import PeelAndStickForm from './PeelAndStickForm';
import BuiltUpRoofMaterialForm from './BuiltUpRoofMaterialForm';
import RoofPanelCutListForm from './RoofPanelCutListForm';
import ALXMaterialForm from './ALXMaterialForm';
import LumberForm from './LumberForm';
import FlashingsForm from './FlashingsForm';
import MetalRoofFlashingForm from './MetalRoofFlashingForm';

const PermitFormSelector = ({ formType, projectId, currentPermit, onClose }) => {
  switch (formType) {
    case 'bidNotes':
      return (
        <BidNotesForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'permitRequestForm':
      return (
        <PermitRequestForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'preliminaryInfo':
      return (
        <PreliminaryInfoForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'projectChecklist':
      return (
        <ProjectChecklistForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'dailyChecklist':
      return (
        <DailyChecklistForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'warrantyForm':
      return (
        <WarrantyCertificateForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'tileForm':
      return (
        <TileForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'slateForm':
      return (
        <SlateForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'singlePly':
      return (
        <SinglePlyForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'compositionShingle':
      return (
        <CompositionShingleForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'prepDryIn':
      return (
        <PrepDryInForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'peelAndStick':
      return (
        <PeelAndStickForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'builtUpRoofMaterial':
      return (
        <BuiltUpRoofMaterialForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'roofPanelCutList':
      return (
        <RoofPanelCutListForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'alxMaterial':
      return (
        <ALXMaterialForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'lumber':
      return (
        <LumberForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'flashings':
      return (
        <FlashingsForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    case 'metalRoofFlashing':
      return (
        <MetalRoofFlashingForm
          projectId={projectId}
          currentPermit={currentPermit}
          onClose={onClose}
        />
      );
    default:
      return (
        <div className="p-6 text-center">
          <h2 className="text-xl font-semibold mb-4">Form Not Available</h2>
          <p className="text-gray-600 mb-4">
            This form type ({formType}) is not yet implemented or is unavailable.
          </p>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      );
  }
};

export default PermitFormSelector;
